/* eslint-disable @typescript-eslint/return-await */
/* eslint-disable @typescript-eslint/await-thenable */
/* eslint-disable no-param-reassign */
import { isRejectedWithValue } from "@reduxjs/toolkit";
import { AnyAction, Dispatch, Middleware } from "redux";
import { ApiException } from "app/ApiClient";
import { normalizeApiError } from "utils/errorHelper";

const COMMON_INTERNAL_SERVER_ERROR =
  "Error 500: Internal server issue. Contact the Analytics and Data Engineering team for help.";
export const apiExceptionMiddleware: Middleware = () => (next: Dispatch<AnyAction>) => async (action: AnyAction) => {
  processApiException(action);
  return await next(action);
};

function processApiException(action: AnyAction) {
  if (isRejectedWithValue(action)) {
    if (action.payload) {
      if (ApiException.isApiException(action.payload)) {
        const { payload } = action;
        if(payload && payload.result ){
          action.error = normalizeApiError(payload);
        }
        else {
          action.error = new Error(COMMON_INTERNAL_SERVER_ERROR);
        }
      }
    }
  }
}
